import 'core-js/es6/promise'; // thanks IE
import 'core-js/es6/set';
import 'core-js/es6/map';
export { default as wrapRootElement } from './src/ReduxWrapper';
